import React from 'react';

import {
  EditLessonForm,
  findLessonByLessonType,
  LESSON_TYPES,
  PlaylistField,
} from 'features/classCreation';
import DiscussionSwitch from '../DiscussionSwitch';
import EditableSection from 'components/EditableSection';
import LectureDetails from '../LectureDetails';

function Discussion({ academyTopic }) {
  const { lessons, playlist_owner: playlistOwner } = academyTopic || {};
  const discussion = findLessonByLessonType({
    lessons,
    lessonType: LESSON_TYPES.liveLecture,
  });

  return (
    <>
      <div className="row align-c dark bold m-b-m">
        Discussion <DiscussionSwitch academyTopic={academyTopic} />
      </div>
      {discussion && (
        <>
          <LectureDetails academyTopic={academyTopic} />
          <PlaylistField
            playlistOwner={playlistOwner}
            className="m-b-s"
          />
          <EditableSection
            canEdit
            title="Discussion"
            titleClassName="hint"
            className="m-b-s"
          >
            {(editableProps) => (
              <EditLessonForm
                {...editableProps}
                academyTopicId={academyTopic.id}
                value={discussion}
                label="Discussion"
              />
            )}
          </EditableSection>
        </>
      )}
    </>
  );
}

export default Discussion;
